import Card from "../../../../shared/components/Card";
import Flex from "../../../../shared/components/Flex";
import Padding from "../../../../shared/components/Padding";
import Pill from "../../../../shared/components/Pill";
import { SensorDataDto } from "../../api/sensorDataApi";
import Text from "../../../../shared/components/Text";
import { useAppDispatch, useAppSelector } from "../../../../shared/store/store";
// import getStatusGroupByStatusId from "../../utils/getStatusGroupByStatusId";
import { useEffect, useMemo } from "react";
import IcoLocation from "../../../../assets/img/img_location.png";
import Spacer from "../../../../shared/components/Spacer";
import Seperator from "../../../../shared/components/Seperator";
import IcoTemperature from "../../../../assets/img/ico_temp.svg";
import IcoWind from "../../../../assets/img/ico_wind.svg";
import IcoHumidity from "../../../../assets/img/ico_humidity.svg";
import Bubble from "../../../../shared/components/Bubble";
import { setSelectedSensor } from "../../slice/sensorDashboardSlice";
import statusToColor from "../../utils/statusToColor";
import { useSmallDevice } from "../../../../shared/hooks/useDevice";
import { statusGroupFromStatus } from "../../utils/useSensor";

function MarkerInfo(sensorData: SensorDataDto) {
    const dispatch = useAppDispatch();
    // const statusGroup = getStatusGroupByStatusId(sensorData.lastStatus, sensorStatusNames ?? []);
    const smallDevice = useSmallDevice();
    // const statusInfo = useMemo(() => {
    //     const status = sensorStatusNames?.find(s => s.codeId === sensorData.lastStatus);
    //     return {
    //         name: status?.codeName ?? "-",
    //         groupName: status?.codeGroupName ?? "",
    //         color: status?.codeGroupName ? statusToColor(status.codeGroupName).color : "rgba(62, 99, 237, 1)",
    //         backgroundColor: status?.codeGroupName ? statusToColor(status.codeGroupName).backgroundColor : "rgba(27, 39, 53, 0.1)"
    //     };
    // }, [sensorStatusNames, sensorData.lastStatus]);
    // const handleClick = () => {
    //     dispatch(setSelectedSensor(sensorData));
    // };

    // useEffect(() => {}, [
    //     sensorStatusNames,
    //     // statusGroup
    // ])
    return (
        <Bubble 
            style={{zIndex: 1000, isolation: "isolate", pointerEvents: "auto", userSelect: "none"}}
            // onClick={handleClick}
            onMouseMove={(e) => e.stopPropagation()}
            onMouseEnter={(e) => e.stopPropagation()}
            onMouseLeave={(e) => e.stopPropagation()}
        >
            <Padding padding={16}>
                <Flex
                    alignItems="center"
                    justifyContent="space-between"
                    gap={10}
                >
                    <Pill padding={0} style={{ border: "none"}} backgroundColor="transparent" icon={<Flex justifyContent="center" alignItems="center"><img style={{filter: "brightness(0)"}} src={"/images/ico_star.svg"} alt=""/></Flex>} width={"fit-content"} text={<Text weight={"semibold"}>{sensorData.sensorAlias}</Text>}/>
                    <Pill
                        height={26}
                        paddingX={15}
                        paddingY={6}
                        color={statusToColor(statusGroupFromStatus(sensorData.lastStatus)).backgroundColor}
                        border={0}
                        style={{borderRadius: 4}}
                        text={<Text weight={"semibold"} size={12} color={statusToColor(statusGroupFromStatus(sensorData.lastStatus)).color}>{sensorData.lastStatus}</Text>}
                    />
                </Flex>
                <Spacer direction="vertical" size={8} />
                <Seperator/>
            </Padding>
            <Padding padding={6} paddingTop={0}>
                <Text style={{marginLeft: 8, maxWidth: "384px", wordBreak: "break-all"}} weight={"semibold"} noWrap={false}>{sensorData.sensorAddress}</Text>
                <Spacer direction="vertical" size={12} />
                <Card fullWidth shadow={0} border={0} backgroundColor="#F5F7F9" padding={12}>
                    <Flex
                        width={smallDevice ? 300 : 380}
                        alignItems="center"
                        justifyContent={"space-around"}
                        overflowX="auto"
                        gap={12}
                        >
                        <Flex alignItems="center" gap={4}>
                            <img src="/images/ico_temp_red.png" style={{ display: "block" }} alt="온도" />
                            <Flex>
                             {!smallDevice  && <Text variant={"span"} weight={"medium"}>온도 </Text>}
                                <Text weight={"semibold"} style={{width: "4ch"}} textAlign={smallDevice ? "center" : "right"}>{sensorData.lastTmpr}</Text><Text weight={"semibold"}>℃</Text>
                            </Flex>
                        </Flex>
                        <Flex alignItems="center" gap={4}>
                            <img src="/images/ico_humidity.png" style={{ display: "block" }} alt="습도" />
                            <Flex>
                             {!smallDevice  && <Text weight={"medium"}>습도 </Text>}
                                <Text style={{width: "4ch"}} textAlign={smallDevice ? "center" : "right"} weight={"semibold"}>{sensorData.lastHumidity ? sensorData.lastHumidity : "-" }</Text><Text weight={"semibold"}>%</Text>
                            </Flex>
                        </Flex>
                        <Flex alignItems="center" gap={4}>
                            <img src="/images/ico_wind.png" style={{ display: "block" }} alt="풍속" />
                            <Flex>
                             {!smallDevice  && <Text weight={"medium"}>풍속 </Text>}
                                <Text style={{width: "3.4ch"}} textAlign={smallDevice ? "center" : "right"} weight={"semibold"}>{sensorData.lastWind ? sensorData.lastWind : "-" }</Text><Text weight={"semibold"}>m/s</Text>
                            </Flex>
                        </Flex>
                    </Flex>
                </Card>
            </Padding>
        </Bubble>
    )
}

export default MarkerInfo;
